import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import dark from "../assets/images/logo-dark.svg";
import light from "../assets/images/logo-light.svg";

import shape from "../assets/images/bg-shape.png";
import { changeLayoutDirection, changeLayoutMode } from "../slices/thunk";
import { useDispatch } from "react-redux";
import { createSelector } from "reselect";
import { useSelector } from "react-redux";

const PagesLayout = ({ children }: any) => {
  const dispatch = useDispatch<any>();

  const selectLayoutState = (state: any) => state.Layout;
  const selectLayoutProperties = createSelector(
    selectLayoutState,
    (layout: any) => ({
      currentLayoutMode: layout.currentLayoutMode,
      currentLayoutDirection: layout.currentLayoutDirection,
    })
  );
  // State from Redux
  const { currentLayoutMode, currentLayoutDirection } = useSelector(
    selectLayoutProperties
  );

  useEffect(() => {
    if (currentLayoutMode || currentLayoutDirection) {
      window.dispatchEvent(new Event("resize"));
      dispatch(changeLayoutMode(currentLayoutMode));
      dispatch(changeLayoutDirection(currentLayoutDirection));
    }
  }, [dispatch, currentLayoutMode, currentLayoutDirection]);

  // Ltr & Rtl
  const [isDirection, setIsDirection] = useState(false);
  const toggleDirection = () => {
    setIsDirection(!isDirection);
    const newDirection = isDirection ? "ltr" : "rtl";
    dispatch(changeLayoutDirection(newDirection));
  };

  return (
    <React.Fragment>
      <div
        className="bg-[#f9fbfd] text-black dark:bg-darklight bg-cover bg-no-repeat"
        style={{ backgroundImage: `url(${shape})` }}
      >
        <header>
          <nav className="px-4 lg:px-7 py-4 max-w-[1440px] mx-auto">
            <div className="flex flex-wrap items-center justify-between">
              <Link to="/index" className="flex items-center">
                <img
                  src={dark}
                  className="mx-auto dark-logo h-7 dark:hidden"
                  alt="logo"
                />
                <img
                  src={light}
                  className="hidden mx-auto light-logo h-7 dark:block"
                  alt="logo"
                />
              </Link>
              <div className="flex items-center lg:order-2">
                <Link
                  to="/signup"
                  className="btn bg-purple border-purple text-white hover:bg-purple/[0.85] hover:border-purple/[0.85]"
                >
                  Buy Now
                </Link>
              </div>
            </div>
          </nav>
        </header>

        {children}

        <footer className="py-5 text-center text-black dark:text-white/80 max-w-[1440px] mx-auto">
          <div>
            &copy; {new Date().getFullYear()} Sliced.{" "}
            <span>
              Crafted with{" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                className="w-4 h-4 inline-block relative -mt-[2px]"
              >
                <path
                  d="M12.001 4.52853C14.35 2.42 17.98 2.49 20.2426 4.75736C22.5053 7.02472 22.583 10.637 20.4786 12.993L11.9999 21.485L3.52138 12.993C1.41705 10.637 1.49571 7.01901 3.75736 4.75736C6.02157 2.49315 9.64519 2.41687 12.001 4.52853Z"
                  className="fill-purple"
                ></path>
              </svg>{" "}
              by SRBThemes
            </span>
          </div>
        </footer>
      </div>

      <button
        type="button"
        className="fixed z-50 px-4 text-white border-gray-200 shadow-lg h-11 ltr:right-0 rtl:left-0 bg-purple ltr:rounded-l-md rtl:rounded-r-md top-1/3"
        onClick={toggleDirection}
      >
        {isDirection === false ? (
          <span className="rtl:hidden">RTL</span>
        ) : (
          <span className="ltr:hidden">LTR</span>
        )}
      </button>
    </React.Fragment>
  );
};

export default PagesLayout;
